export default {
  settings: {
    title: 'การตั้งค่า',
    account_related: 'ข้อมูลบัญชี',
    user_related: 'ข้อมูลผู้ใช้',
    add_user_title: 'เพิ่มผู้ใช้',
    edit_user_title: 'แก้ไขผู้ใช้',
    label: {
      enabled: 'เปิดใช้งานแล้ว',
      not_set: 'ไม่ได้ตั้งค่า',
    },
    company: {
      title: 'ข้อมูลบริษัท',
      name: 'ชื่อบริษัท',
      english_name: 'English name',
      scale: 'จำนวนพนักงาน',
      industry_type: 'อุตสาหกรรม',
      plan: 'วางแผน',
      location: 'ที่อยู่',
      allowed_ip: 'ที่อยู่ IP ที่อนุญาต',
      mfa: 'การยืนยันตัวตนทาง SMS',
      sales_amount: 'รายได้',
      country: 'ประเทศ',
    },
    contract_plans: {
      buyer: 'แผนผู้ซื้อ',
      supplier: 'แผนซัพพลายเออร์',
    },
    user: {
      title: 'รายการผู้ใช้',
      name: 'ชื่อ',
      first_name: 'ชื่อจริง',
      last_name: 'นามสกุล',
      email: 'ที่อยู่อีเมล',
      email_unverified: 'ก่อนลงทะเบียน',
      password: 'รหัสผ่าน',
      password_protection: 'ซ่อนไว้เพื่อจุดประสงค์ด้านความปลอดภัย',
      phone_number: 'หมายเลขโทรศัพท์',
      role: {
        title: 'สิทธิ์ในการเข้าถึง',
        admin: 'การดูแลระบบ',
        general: 'ทั่วไป',
      },
      locale: 'เลือกภาษา',
      action: 'การดำเนินการ',
      total: 'ทั้งหมด: {total} (สูงสุด: {max})',
    },
    button: {
      create: 'เพิ่มผู้ใช้',
      edit: '@:common.btn.edit',
      cancel: '@:common.btn.cancel',
      close: '@:common.btn.close',
      add: '@:common.btn.add',
      update: '@:common.btn.update',
      delete: '@:common.btn.delete',
      do_delete: '@:common.btn.delete',
      reset_password: '@:forgot_password.title',
    },
    cautions_title: '【ประกาศ】',
    cautions_01: 'คุณไม่สามารถเปลี่ยนที่อยู่อีเมลของคุณได้ หากต้องการรีเซ็ตอีเมลของคุณ โปรดสร้างผู้ใช้ใหม่',
    cautions_02: 'จำเป็นต้องระบุหมายเลขโทรศัพท์หากเปิดใช้งานการยืนยันตัวตนผ่าน SMS',
    cautions_03: 'หากต้องการรีเซ็ตรหัสผ่านของคุณ โปรดป้อนรหัสยืนยันที่ส่งไปยังที่อยู่อีเมลที่คุณลงทะเบียนไว้ในหน้าจอรีเซ็ตรหัสผ่าน',
    cautions_04: 'การลบผู้ใช้จะไม่ลบข้อมูลคำตอบหรือดัชนีชี้วัด',
    messages: {
      user_update: 'อัปเดตข้อมูลผู้ใช้',
      user_delete: 'ลบผู้ใช้',
      confirm_delete: 'คุณต้องการลบผู้ใช้นี้หรือไม่',
      complete_create: 'เพิ่มข้อมูลบัญชีแล้ว',
      complete_update: 'ข้อมูลผู้ใช้ได้รับการอัปเดตแล้ว',
      complete_delete: 'การลบข้อมูลผู้ใช้เสร็จสมบูรณ์',
      disabled_delete: 'ผู้ใช้อย่างน้อยหนึ่งรายต้องเป็นผู้มีอำนาจ "ผู้ดูแลระบบ"',
      disabled_delete_by_auth: 'เฉพาะผู้ดูแลระบบเท่านั้นที่สามารถลบได้',
      invalid_form: 'อินพุตไม่ถูกต้อง',
      caution_title: '@:list_table_filter.csv_modal_cautionary_note_title',
      caution_one: 'หลังจากคลิก "เพิ่ม" ระบบจะส่งอีเมลยืนยันไปยังที่อยู่อีเมลที่คุณป้อน \nจากนั้นระบบจะส่งอีเมลแจ้ง ID เข้าสู่ระบบและรหัสผ่านของคุณ',
      caution_two: 'จำเป็นต้องระบุหมายเลขโทรศัพท์หากเปิดใช้งานการยืนยันตัวตนผ่าน SMS',
      caution_three: 'สามารถเพิ่มผู้ใช้ได้สูงสุด 5 คน',
      user_add_title: '@:settings.button.create',
      user_add_message_one: 'เราได้ส่งอีเมลไปยังที่อยู่อีเมลที่คุณให้ไว้แล้ว ',
      user_add_message_two: 'โปรดตรวจสอบอีเมลของคุณและทำตามคำแนะนำในอีเมลเพื่อเข้าสู่ระบบ',
    },
    tips: {
      role: 'หน่วยงาน "ผู้ดูแลระบบ" สามารถเพิ่มและลบผู้ใช้ได้ แต่หน่วยงาน "ทั่วไป" ไม่สามารถทำได้',
      locale: 'คุณสามารถเลือกการตั้งค่าภาษาเริ่มต้นได้หลังจากเข้าสู่ระบบ',
    },
    // english_name_edit_modal_title: "",
    // english_name_input_label: "",
    // english_name_placeholder: "",
    reset_password: {
      title: '@:forgot_password_submit.title',
      content: 'คุณแน่ใจหรือไม่ว่าต้องการออกจากระบบและไปที่หน้าการรีเซ็ตรหัสผ่าน ในหน้าการรีเซ็ตรหัสผ่าน โปรดป้อนรหัสยืนยันที่อยู่ในอีเมลที่ส่งไปยังที่อยู่อีเมลที่คุณลงทะเบียนไว้',
      reset: 'รีเซ็ตรหัสผ่าน',
    },
  },
}
